import { render } from "./BatchView.vue?vue&type=template&id=531f3998&scoped=true"
import script from "./BatchView.vue?vue&type=script&lang=js"
export * from "./BatchView.vue?vue&type=script&lang=js"

import "./BatchView.vue?vue&type=style&index=0&id=531f3998&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531f3998"]])

export default __exports__